import styled from 'styled-components';

export const StyledIconWrapper = styled.div`
    font-size: 48px;
`;
